// TODO(): type OutputAction payloads
export enum OutputAction {
  Handshake = 'Handshake',
  Download = 'Download', // TODO: Remove
  Logout = 'Logout',
  GetDownloads = 'GetDownloads',
  StartDownload = 'StartDownload',
  DeleteDownload = 'DeleteDownload',
  PauseDownload = 'PauseDownload',
  ResumeDownload = 'ResumeDownload',
  PlayDownload = 'PlayDownload',
  GetAppSettings = 'GetAppSettings',
  DownloadQuality = 'DownloadQuality',
}